const countdown = {
	el: {
		container: document.querySelector('.js-countdown')
	},

	vars: {
		url: null,
		hasFinished: false
	},

	fxSimulateClick(url) {
		const modalContainer = this.el.container.closest('.modal__content'),
			link = document.createElement('a')

		link.href = url
		link.target = '_blank'
		link.classList.add('d-none')

		modalContainer.append(link)
		
		link.dispatchEvent(new Event('click'))
		
		link.addEventListener('click', () => {
			window.open(url, '_blank')
		})
		link.click()
		link.remove()
	},

	async fxRedirect(endpoint) {		
		try {
			const response = await fetch(endpoint),
				url = await response.text()

			if(url) {
				this.vars.url = url
				this.vars.hasFinished = true
			}
			//window.location.href = url
			
			// this.el.container.setAttribute('href', url)
			// this.el.container.setAttribute('target', '_blank')
			
			// -this.fxSimulateClick(url)
		} catch (error) {
			console.log(error)
		}
	},

	fxCounter (seconds) {
		const action = this.el.container.dataset.action
		this.fxRedirect(action)
		
		if(seconds <= 0) {
			if(this.vars.url !== null && this.vars.hasFinished) {
				//redirect
				modal.fxCloseModal(this.el.container)
				window.location.href = this.vars.url

			} else {
				//error
				const modalContent = this.el.container.closest('.modal__content'),
					errorMessage = modalContent.querySelector('.js-error-msg')

				errorMessage.classList.remove('d-none')
				errorMessage.nextElementSibling.classList.add('d-none')

				setTimeout(() => {
					//close modal
					modal.fxCloseModal(this.el.container)
					errorMessage.classList.add('d-none')
					errorMessage.nextElementSibling.classList.remove('d-none')
				}, 5000)
			}

		} else {
			seconds--
			this.el.container.innerHTML = seconds
			setTimeout(() => {
				this.fxCounter(seconds)
			}, 1000)
		}
	},

	init() {
		if(!this.el.container) return
	}
}

countdown.init()